import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { Col, Grid, Row } from "antd";
import { useTrackVisibility } from "react-intersection-observer-hook";

const { useBreakpoint } = Grid;

export function PrivateJetTravelServices({ the_royal_air_difference = {} }) {
	const screens = useBreakpoint();
	const [ref] = useTrackVisibility();
	const { desktop_background_photo, mobile_background_photo } = the_royal_air_difference;
	return (
		<BackgroundContainer ref={ref} imgBg={screens.xs ? mobile_background_photo : desktop_background_photo}>
			<HomeContactContainer>
				<WrapperContent>
					<RATypography
						variant={screens?.md ? "h2" : "h4"}
						color="#fff"
						style={{ textAlign: "center" }}
						bottom={40}
					>
						{the_royal_air_difference?.title || ""}
					</RATypography>
					<Row>
						<Col xxl={6} xl={6} lg={12} md={24} sm={24} xs={24}>
							<CardServiceItem
								dividerRight={screens?.lg}
								dividerBottom={!screens?.xl}
								icon={<TextAmount>01</TextAmount>}
								title={the_royal_air_difference?.hight_light1?.title || ""}
								description={the_royal_air_difference?.hight_light1?.description || ""}
							/>
						</Col>
						<Col xxl={6} xl={6} lg={12} md={24} sm={24} xs={24}>
							<CardServiceItem
								dividerRight={screens?.xl}
								dividerBottom={!screens?.xl}
								icon={<TextAmount>02</TextAmount>}
								title={the_royal_air_difference?.hight_light2?.title || ""}
								description={the_royal_air_difference?.hight_light2?.description || ""}
							/>
						</Col>
						<Col xxl={6} xl={6} lg={12} md={24} sm={24} xs={24}>
							<CardServiceItem
								dividerRight={screens?.lg}
								dividerBottom={!screens?.lg}
								icon={<TextAmount>03</TextAmount>}
								title={the_royal_air_difference?.hight_light3?.title || ""}
								description={the_royal_air_difference?.hight_light3?.description || ""}
							/>
						</Col>
						<Col xxl={6} xl={6} lg={12} md={24} sm={24} xs={24}>
							<CardServiceItem
								icon={<TextAmount>04</TextAmount>}
								title={the_royal_air_difference?.hight_light4?.title || ""}
								description={the_royal_air_difference?.hight_light4?.description || ""}
							/>
						</Col>
					</Row>
				</WrapperContent>
			</HomeContactContainer>
		</BackgroundContainer>
	);
}

const CardServiceItem = ({ icon, title = "", description = "", dividerRight = false, dividerBottom = false }) => {
	const screens = useBreakpoint();
	return (
		<CardServiceItemContainer
			dividerRight={dividerRight ? "true" : "false"}
			dividerBottom={dividerBottom ? "true" : "false"}
		>
			<WrapperCardItem wrap={screens?.lg}>
				<Col lg={24} xl={24} xxl={24}>
					{icon}
				</Col>
				<Col>
					<Row justify="start" align="top">
						<RATypography
							variant="sub-heading3"
							color="#fff"
							style={{
								lineHeight: "30px",
								fontSize: screens.xs ? "16px" : "20px",
							}}
						>
							{title}
						</RATypography>
					</Row>
					<Row>
						<RATypography
							variant="body3"
							color="#fff"
							style={{
								opacity: 0.7,
								fontSize: screens.xs ? "14px" : "16px",
							}}
							top={4}
						>
							{description}
						</RATypography>
					</Row>
				</Col>
			</WrapperCardItem>
		</CardServiceItemContainer>
	);
};

const CardServiceItemContainer = styled.div`
	height: 100%;
	width: 100%;
	${({ dividerRight }) => dividerRight === "true" && `border-right: 1px solid rgba(255, 255, 255, 0.2);`}
	${({ dividerBottom }) => dividerBottom === "true" && `border-bottom: 1px solid rgba(255, 255, 255, 0.2);`}
    -webkit-background-clip: padding-box; /* for Safari */
	background-clip: padding-box;
`;
const BackgroundContainer = styled.div`
	width: 100vw;
	height: 100vh;
	position: relative;
	background: ${(props) =>
		`url("/images/layout/bg_transparent.png"), url(${props.imgBg || "/images/layout/service_j1s_banner.png"})`};
	background-size: cover;
	background-repeat: no-repeat, no-repeat;
	background-position:
		bottom left,
		top right;
	display: flex;
	flex-direction: column;
	align-items: center;
	@media (max-width: 576px) {
		background: ${(props) =>
			`url("/images/layout/bg_transparent_mobile.png"), url(${
				props.imgBg || "/images/layout/service_j1s_banner.png"
			})`};
		background-size: cover;
	}
`;
const WrapperCardItem = styled(Row)`
	gap: 8px;
	padding: 20px;
	@media (max-width: 576px) {
		padding: 12px 0;
	}
`;
const HomeContactContainer = styled.div`
	max-width: 1442px;
	padding: 0px 136px;
	width: 100%;
	top: 15%;
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	@media (max-width: 1200px) {
		padding: 0px 40px;
	}
	@media (max-width: 991px) {
		padding: 0px 32px;
	}
	@media (max-width: 767px) {
		padding: 0px 24px;
	}
	@media (max-width: 576px) {
		padding: 0;
	}
`;
const WrapperContent = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	padding: clamp(40px, 4vw, 64px);
`;
const TextAmount = styled.div`
	font-family: "Gilda Display";
	font-style: normal;
	font-weight: 400;
	font-size: 32px;
	line-height: 36px;
	display: flex;
	align-items: center;
	text-align: center;
	letter-spacing: 0.005em;
	color: #d5d5d5;
`;
